var semanticTokens = {
    colors: {
        primary: {
            100: "#E6EEEE",
            200: "#96B8B9",
            300: "#6B9B9C",
            400: "#2B7072",
            500: "#2C696A",
            600: "#175457",
            700: "#114A4D",
            800: "#0A4042",
            900: "#18189A",
        },
        secondary: {
            100: "#FEF9F1",
            200: "#F0D9B0",
            300: "#EAC78A",
            400: "#E3B466",
            500: "#DDA247",
            600: "#C78B35",
            700: "#9F6F2A",
            800: "#77531E",
            900: "#4F3713",
        },
        neutrals: {
            white: "#FFFFFF",
            50: "#EEF1F9",
            100: "#FCFDFF",
            200: "#F7F9FC",
            300: "#F0F3F7",
            400: "#DADEE5",
            500: "#6B7280",
            600: "#6A7381",
            700: "#363C45",
            800: "#1F2329",
            900: "#111827",
        },
        transparent: {
            100: "rgba(247, 249, 252, 0.55)",
            200: "rgba(203, 211, 223, 0.55)",
            300: "rgba(0, 0, 0, 0.25)",
            400: "rgba(0, 0, 0, 0.75)",
        },
        success: {
            100: "#F2FBF5",
            200: "#DCF7EB",
            300: "#C1E8D3",
            400: "#B1E1C8",
            500: "#92D5B0",
            600: "#6AD0A1",
            700: "#6AC08D",
            800: "#559D72",
            900: "#4A8160",
        },
        warning: {
            100: "#FFFCF5",
            200: "#FAF2DC",
            300: "#FAEBC3",
            400: "#F7E5B7",
            500: "#F5DDA1",
            600: "#EFCD78",
            700: "#EDBC4D",
            800: "#E0AA3D",
            900: "#B47E12",
        },
        error: {
            100: "#FAEEEF",
            200: "#F8D7D6",
            300: "#F3AEAC",
            400: "#EF8784",
            500: "#EC625C",
            600: "#EB4B38",
            700: "#EA3323",
            800: "#C2291B",
            900: "#9C1F14",
        },
        informational: {
            100: "#F3FDFF",
            200: "#D8F2F8",
            300: "#B3E5F1",
            400: "#A1DEEE",
            500: "#91D8E9",
            600: "#5ECDE6",
            700: "#4CB1CF",
            800: "#2D94B2",
            900: "#1F83A1",
        },
        disable: {
            bg: "#D9D9D9",
            color: "#8F8F8F",
        },
        focused: "#4597F7",
        placeholder: "#EFEFEF",
        link: {
            color: "#2C6FD4",
            hover: "#1A62CF",
        },
        gradients: {
            "two-tone": "linear-gradient(180deg, #7DC1C3 0%, #D8F1F2 100%)",
            "three-tone": "linear-gradient(180deg, #003C3D 0%, #105154 50.11%, #59979B 100%)",
        },
        chart: {
            1: "#74E4DA",
            2: "#ED64A4",
            3: "#F3DC46",
            4: "#BABFC5",
            5: "#60A9FF",
            6: "#C8BAEE",
            7: "#585E67",
            mono1: "#C3EAFF",
            mono2: "#8ED7FF",
            mono3: "#60A9FF",
            mono4: "#2F73DA",
            mono5: "#034AB3",
            mono6: "#002966",
        },
        fico: {
            poor: "#CA3928",
            fair: "#F89922",
            good: "#F2EA1B",
            verygood: "#A6CE39",
            exceptional: "#4EB748",
        },
        grays: {
            1: "#FCFCFE",
            2: "#FAFAFC",
        },
        divider: {
            1: "#E4E8EE",
            2: "#CBD5E0",
        },
    },
};

export { semanticTokens as default };
//# sourceMappingURL=semantic.js.map
